import React from 'react'
import FormLayout from './FormLayout'
import ChangePassword from './WithUi/ChangePassword'

function ChangePasswordLayout() {
  return (
   <FormLayout>
   <ChangePassword/>
   </FormLayout>
  )
}

export default ChangePasswordLayout